<section
  class="section-content-split"
  [style.--padding-top.px]="design().padding.top"
  [style.--padding-bottom.px]="design().padding.bottom"
>
  <picture class="section-content-split__image" [paiPicture]="data().image" sizeSm="100vw" size="50vw"></picture>

  <div class="section-content-split__content">
    @for (item of data().splitContent; track item.id) {
      <ng-template [paiInsertDynamicContent]="item" />
    }
  </div>
</section>
